<template>
  <v-flex class="affected-students-width pt-2">
    <span>{{$t('admin.alerts.new.affected_students')}}</span>
    <v-chip class="custom-chip" disabled small>
      <v-btn id="affected-students-btn" aria-label="affected-students" fab small color="primary" @click="studentCount"
             class="chip-btn">
        <v-progress-circular v-if="affectedStudentsLoading" indeterminate size="20"/>
        <v-icon v-if="!affectedStudentsLoading" color="white" class="chip-icon" aria-hidden="false" small>send</v-icon>

      </v-btn>
      <span v-if="affectedStudents === -1">{{$t('admin.alerts.new.request_affected_students')}}</span>
      <span id="affected-students-count" v-else><animated-counter :number="affectedStudents"/> </span>

    </v-chip>
  </v-flex>
</template>
<script>
  import { GET_STUDENT_AFFECTED_COUNT } from '../../../store/action-types'
  import { mapState } from 'vuex'
  import AnimatedCounter from './AnimatedCounter'

  export default {
    components: {
      AnimatedCounter
    },
    name: 'button-chip',
    props: {
      alertId: {
        type: Number
      }
    },
    computed: {
      ...mapState({
        affectedStudents: state => state.admin.studentAffectedCount,
        affectedStudentsLoading: state => state.admin.studentAffectedCountLoading
      })
    },
    methods: {
      studentCount () {
        if (!this.affectedStudentsLoading) {
          this.$store.dispatch(GET_STUDENT_AFFECTED_COUNT, this.alertId)
        }
      }
    }
  }
</script>
<style scoped>

  .custom-chip {
    font-size: 14px;
    font-weight: 500;
    margin: 4px 6px;
  }

  .chip-icon {
    transform: rotate(-45deg);
  }

  .chip-btn {
    margin-left: -15px;
    width: 34px;
    height: 34px
  }

  .affected-students-width {
    max-width: 170px
  }
</style>



// WEBPACK FOOTER //
// src/components/settings/alert/ButtonChip.vue